export default {
  default: {
    contactsTitle: 'CONTACTS',
    teamsTitle: 'TEAMS',
    usersTitle: 'USERS',
  },
}
